async function OilSave(oilid, oilname, oilviscosity, description) {

    if (true) {

        let response;

        let params = {
            "@OilID": oilid,
            "@OilName": oilname,
            "@Viscosity": oilviscosity,
            "@Description": description
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "99",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default OilSave;